import { cloneElement, ReactElement } from "react";

import { useMenuContext } from "./MenuContext";

export type MenuTriggerProps = {
  children: ReactElement;
};

/**
 * Wires open/close behavior onto a single child element (e.g. a button)
 * without rendering an extra DOM node, so the caller's own trigger
 * component (styling, ref-forwarding, etc.) is preserved as-is.
 */
const MenuTrigger = ({ children }: MenuTriggerProps) => {
  const { open, toggle, triggerRef } = useMenuContext();

  const childRef = (children as any).ref;
  const mergedRef = (node: HTMLElement | null) => {
    (triggerRef as any).current = node;
    if (typeof childRef === "function") childRef(node);
    else if (childRef && typeof childRef === "object") childRef.current = node;
  };

  return cloneElement(children, {
    ref: mergedRef,
    onClick: (e: any) => {
      children.props.onClick?.(e);
      if (!e.defaultPrevented) toggle();
    },
    "aria-haspopup": "menu",
    "aria-expanded": open,
  });
};

export default MenuTrigger;
